import { IVideoMediafile, IVideoStreamEmenuMediafile } from '../types';
import { assignOrderByIndex, sortItemsByOrder } from '../utils';

export const getDefaultVideoStreamInput = (
  title: string,
  description: string,
  videoMediafiles: IVideoMediafile[],
  emenuMediafiles: IVideoStreamEmenuMediafile[] = []
) => {
  const orderedItems = assignOrderByIndex(
    sortItemsByOrder([
      ...videoMediafiles.map((it) => ({ ...it, itemType: 'video' as const })),
      ...emenuMediafiles.map((it) => ({ ...it, itemType: 'emenu' as const })),
    ])
  );

  return {
    title,
    description,
    videoMediafiles: orderedItems
      .filter((it) => it.itemType === 'video')
      .map((videoMediafile) => ({
        mediafileId: videoMediafile.mediafile?.id || videoMediafile.id?.replace(/-.*/, '') || '',
        playDuration: videoMediafile.playDuration ?? 0,
        title: videoMediafile.title || '',
        order: videoMediafile.order,
        id:
          videoMediafile.id && !videoMediafile.isCopy && videoMediafile.mediafile
            ? videoMediafile.id?.replace(/-.*/, '')
            : undefined,
      })),
    emenuMediafiles: orderedItems
      .filter((it) => it.itemType === 'emenu')
      .map((em) => ({
        emenuMediafileId: em.emenuMediafileId,
        id: em.id,
        order: em.order,
        playDuration: em.playDuration,
        title: em.title || '',
        playCount: em.playCount || 1,
      })),
  };
};
